package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class ContentConnectionRelationType(private val literal: String) : IEnumType {
	相关("相关"),
	排斥("排斥");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "content_connection_relation_type"}
	override fun getLiteral(): String {return literal}
}
